

import React, { useState } from 'react';
import './Salsecommtionsectting.css';
// import { RAZORPAY_KEY_ID } from '../../../config/api';

const Sourcing = () => {
  // Table data with all fields
  const [tableData, setTableData] = useState([
    {
      id: 1,
      srNo: 1,
      leadName: 'Rohit Sharma',
      mobile: '+91 98765 43210',
      email: 'rohit@acme.in',
      whatsapp: '+91 98765 43210',
      company: 'Acme Industries',
      source: 'Referral',
      location: 'Mumbai',
      assigned: 'Priya (Exec)',
      status: 'New',
      enquiryDate: '2024-01-15',
      description: 'Looking for industrial automation solutions',
      vertical: 'Manufacturing & Automation',
      activity: 'Demo scheduled',
      remarks: 'Follow up in Q3',
      paymentStatus: 'Pending',
      amount: 150,
      isFree: false
    },
    {
      id: 2,
      srNo: 2,
      leadName: 'Anita Desai',
      mobile: '+91 87654 32109',
      email: 'anita@nimbus.io',
      whatsapp: '+91 87654 32109',
      company: 'Nimbus Tech',
      source: 'Internet Research',
      location: 'Bangalore',
      assigned: 'Karan (Exec)',
      status: 'New',
      enquiryDate: '2024-01-15',
      description: 'Interested in cloud migration services',
      vertical: 'IT & Cloud Services',
      activity: 'Initial call done',
      remarks: 'Send proposal by EOW',
      paymentStatus: 'Pending',
      amount: 250,
      isFree: false
    },
    {
      id: 3,
      srNo: 3,
      leadName: 'Vikram Mehta',
      mobile: '+91 76543 21098',
      email: 'vikram@orbit.co',
      whatsapp: '+91 76543 21098',
      company: 'Orbit Logistics',
      source: 'Social Media',
      location: 'Delhi',
      assigned: 'Priya (Exec)',
      status: 'New',
      enquiryDate: '2024-01-15',
      description: 'Needs fleet management software',
      vertical: 'Logistics & Supply Chain',
      activity: 'Requirement gathering',
      remarks: 'Demo scheduled for Monday',
      paymentStatus: 'N/A',
      amount: 0,
      isFree: true
    },
    {
      id: 4,
      srNo: 4,
      leadName: 'Sara Khan',
      mobile: '+91 65432 10987',
      email: 'sara@bluepeak.in',
      whatsapp: '+91 65432 10987',
      company: 'BluePeak Foods',
      source: 'Physical Visit',
      location: 'Pune',
      assigned: 'Karan (Exec)',
      status: 'New',
      enquiryDate: '2024-01-15',
      description: 'Interested in cold storage monitoring',
      vertical: 'Food & Beverage',
      activity: 'Product intro sent',
      remarks: 'Share brochure',
      paymentStatus: 'Pending',
      amount: 180,
      isFree: false
    },
    {
      id: 5,
      srNo: 5,
      leadName: 'Free User',
      mobile: '+91 12345 67890',
      email: 'free@demo.com',
      whatsapp: '+91 12345 67890',
      company: 'Free Demo Corp',
      source: 'Social Media',
      location: 'Mumbai',
      assigned: 'Admin',
      status: 'New',
      enquiryDate: '2024-01-20',
      description: 'Free trial lead - no payment needed',
      vertical: 'Demo',
      activity: 'Free access granted',
      remarks: 'No payment required',
      paymentStatus: 'N/A',
      amount: 0,
      isFree: true
    }
  ]);

  const [isNewLeadModalOpen, setIsNewLeadModalOpen] = useState(false);
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const [isConvertModalOpen, setIsConvertModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [bulkData, setBulkData] = useState('');
  const [processingPaymentId, setProcessingPaymentId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [formData, setFormData] = useState({
    leadName: '',
    mobile: '',
    email: '',
    whatsapp: '',
    company: '',
    source: 'Internet Research',
    location: '',
    assignedTo: 'Priya (Exec)',
    enquiryDate: '',
    description: '',
    vertical: '',
    activity: '',
    remarks: '',
    notes: '',
    amount: '',
    isFree: false
  });

  const sourceOptions = ['Referral', 'Internet Research', 'Social Media', 'Physical Visit', 'Cold Call', 'Email Campaign'];
  const assigneeOptions = ['Priya (Exec)', 'Karan (Exec)', 'Aarav (Admin)', 'Neha (Manager)', 'Raj (Sales)'];

  // Function to check if lead source is Social Media
  const isSocialMediaLead = (source) => {
    return source?.toLowerCase() === 'social media';
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    // If source is changed to Social Media, automatically set as free
    if (name === 'source') {
      const isSocialMedia = isSocialMediaLead(value);
      setFormData(prev => ({
        ...prev,
        [name]: value,
        isFree: isSocialMedia ? true : prev.isFree,
        amount: isSocialMedia ? '' : prev.amount
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  const handleAddLead = () => {
    if (!formData.leadName || !formData.email || !formData.company) {
      alert('Please fill required fields: Lead Name, Email, and Company');
      return;
    }

    const isSocialMedia = isSocialMediaLead(formData.source);
    const newId = tableData.length + 1;
    const newLead = {
      id: newId,
      srNo: newId,
      leadName: formData.leadName,
      mobile: formData.mobile || 'Not Provided',
      email: formData.email,
      whatsapp: formData.whatsapp || formData.mobile || 'Not Provided',
      company: formData.company,
      source: formData.source,
      location: formData.location || 'Not Specified',
      assigned: formData.assignedTo,
      status: 'New',
      description: formData.description || '',
      vertical: formData.vertical || '',
      activity: formData.activity || '',
      remarks: formData.remarks || '',
      enquiryDate: formData.enquiryDate || new Date().toISOString().split('T')[0],
      paymentStatus: isSocialMedia || formData.isFree ? 'N/A' : 'Pending',
      amount: isSocialMedia || formData.isFree ? 0 : (formData.amount ? parseFloat(formData.amount) : 0),
      isFree: isSocialMedia || formData.isFree
    };

    setTableData([...tableData, newLead]);
    setFormData({
      leadName: '',
      mobile: '',
      email: '',
      whatsapp: '',
      company: '',
      source: 'Internet Research',
      location: '',
      assignedTo: 'Priya (Exec)',
      description: '',
      vertical: '',
      activity: '',
      remarks: '',
      notes: '',
      enquiryDate: '',
      amount: '',
      isFree: false
    });
    setIsNewLeadModalOpen(false);
    
    if (isSocialMedia) {
      alert('✅ Social Media lead added successfully! (Free lead - No payment required)');
    } else {
      alert('Lead added successfully!');
    }
  };

  const handleConvertLead = () => {
    if (selectedLead) {
      if (!selectedLead.isFree && selectedLead.paymentStatus !== 'Paid') {
        alert('⚠️ Payment required before conversion! Please complete the payment first.');
        return;
      }
      const updatedTableData = tableData.map(lead =>
        lead.id === selectedLead.id ? { ...lead, status: 'Converted' } : lead
      );
      setTableData(updatedTableData);
      alert(`✅ Lead "${selectedLead.leadName}" converted to Enquiry successfully!`);
      setIsConvertModalOpen(false);
      setSelectedLead(null);
    }
  };

  const openConvertModal = (lead) => {
    if (!lead.isFree && lead.paymentStatus !== 'Paid') {
      alert('⚠️ Please complete the payment before converting this lead.');
      return;
    }
    setSelectedLead(lead);
    setIsConvertModalOpen(true);
  };

  const openViewModal = (lead) => {
    setSelectedLead(lead);
    setIsViewModalOpen(true);
  };

  const handleBulkUpload = () => {
    if (!bulkData.trim()) {
      alert('Please paste CSV data');
      return;
    }
    const rows = bulkData.split('\n');
    const newLeads = [];
    let startIndex = 0;
    const firstRow = rows[0].toLowerCase();
    if (firstRow.includes('lead name') || firstRow.includes('name')) {
      startIndex = 1;
    }
    for (let i = startIndex; i < rows.length; i++) {
      const cols = rows[i].split(',');
      if (cols.length >= 4 && cols[0]?.trim()) {
        const newId = tableData.length + newLeads.length + 1;
        const source = cols[5]?.trim() || 'Other';
        const isSocialMedia = isSocialMediaLead(source);
        const isFree = isSocialMedia || cols[14]?.trim().toLowerCase() === 'true' || cols[14]?.trim().toLowerCase() === 'free';
        
        const leadData = {
          id: newId,
          srNo: newId,
          leadName: cols[0]?.trim() || 'Unknown',
          mobile: cols[1]?.trim() || 'Not Provided',
          email: cols[2]?.trim() || 'unknown@email.com',
          whatsapp: cols[3]?.trim() || cols[1]?.trim() || 'Not Provided',
          company: cols[4]?.trim() || 'Unknown Company',
          source: source,
          location: cols[6]?.trim() || 'Not Specified',
          assigned: cols[7]?.trim() || 'Priya (Exec)',
          status: 'New',
          description: cols[8]?.trim() || '',
          vertical: cols[9]?.trim() || '',
          activity: cols[10]?.trim() || '',
          remarks: cols[11]?.trim() || '',
          enquiryDate: cols[12]?.trim() || new Date().toISOString().split('T')[0],
          paymentStatus: isFree ? 'N/A' : 'Pending',
          amount: isFree ? 0 : (parseFloat(cols[13]?.trim()) || 0),
          isFree: isFree
        };
        newLeads.push(leadData);
      }
    }
    if (newLeads.length > 0) {
      setTableData([...tableData, ...newLeads]);
      const socialMediaCount = newLeads.filter(lead => isSocialMediaLead(lead.source)).length;
      alert(`Successfully added ${newLeads.length} leads! (${socialMediaCount} Social Media leads are free)`);
      setIsBulkUploadModalOpen(false);
      setBulkData('');
    } else {
      alert('No valid data found. Please check your format.');
    }
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleDirectPayment = async (lead) => {
    if (lead.paymentStatus === 'Paid') {
      alert('Payment already completed for this lead.');
      return;
    }
    if (lead.isFree) {
      alert('This is a free lead (Social Media or marked as free). No payment required.');
      return;
    }
    setProcessingPaymentId(lead.id);
    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      alert('Failed to load Razorpay SDK. Please check your internet connection.');
      setProcessingPaymentId(null);
      return;
    }
    const options = {
    //   key: `${RAZORPAY_KEY_ID}`,
      amount: Math.round(lead.amount * 100),
      currency: 'INR',
      name: lead.company || 'Company',
      description: `Payment for ${lead.leadName}`,
      image: 'https://your-logo-url.com/logo.png',
      order_id: '',
      handler: function (response) {
        const paymentId = response.razorpay_payment_id;
        setTableData(prevData =>
          prevData.map(item =>
            item.id === lead.id ? { ...item, paymentStatus: 'Paid' } : item
          )
        );
        alert(`✅ Payment Successful!\n\nPayment ID: ${paymentId}\nAmount: ₹${lead.amount}\n\nYou can now convert this lead.`);
        setProcessingPaymentId(null);
      },
      prefill: {
        name: lead.leadName,
        email: lead.email,
        contact: lead.mobile,
      },
      notes: {
        lead_id: lead.id.toString(),
        lead_name: lead.leadName,
        company: lead.company,
      },
      theme: { color: '#3b82f6' },
      modal: {
        ondismiss: function () {
          alert('Payment cancelled by user.');
          setProcessingPaymentId(null);
        }
      }
    };
    const razorpay = new window.Razorpay(options);
    razorpay.on('payment.failed', function (response) {
      const error = response.error;
      alert(`❌ Payment Failed: ${error.description || 'Please try again'}`);
      setTableData(prevData =>
        prevData.map(item =>
          item.id === lead.id ? { ...item, paymentStatus: 'Failed' } : item
        )
      );
      setProcessingPaymentId(null);
    });
    razorpay.open();
  };

  const filteredData = tableData.filter(lead => {
    const matchesSearch =
      lead.amount.toString().includes(searchTerm) ||
      lead.assigned.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.source.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.leadName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.mobile.includes(searchTerm);
    let matchesDate = true;
    if (startDate && lead.enquiryDate) matchesDate = matchesDate && lead.enquiryDate >= startDate;
    if (endDate && lead.enquiryDate) matchesDate = matchesDate && lead.enquiryDate <= endDate;
    return matchesSearch && matchesDate;
  });

  const clearFilters = () => {
    setSearchTerm('');
    setStartDate('');
    setEndDate('');
  };

  const getPaymentInfo = (lead) => {
    if (lead.isFree) {
      if (isSocialMediaLead(lead.source)) {
        return { text: '📱 Social Free', disabled: true, className: 'payment-social-free' };
      }
      return { text: 'Free', disabled: true, className: 'payment-free' };
    }
    if (lead.paymentStatus === 'Paid') return { text: '✓ Paid', disabled: true, className: 'payment-paid' };
    if (lead.paymentStatus === 'Failed') return { text: 'Retry', disabled: false, className: 'payment-failed' };
    if (processingPaymentId === lead.id) return { text: 'Processing...', disabled: true, className: 'payment-processing' };
    return { text: `Pay ₹${lead.amount}`, disabled: false, className: 'payment-pending' };
  };

  return (
    <div className="src-container">
      <div className="src-wrapper">
        <div className="src-filter-section">
          <div className="src-filter-left">
            <div className="src-search-box">
              <span className="src-search-icon">🔍</span>
              <input type="text" placeholder="Search by name, company, email or mobile..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="src-search-input" />
            </div>
            <div className="src-date-filters">
              <input type="date" className="src-date-input" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              <input type="date" className="src-date-input" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              {(startDate || endDate || searchTerm) && (<button className="src-clear-filters" onClick={clearFilters}>✕ Clear</button>)}
            </div>
          </div>
          <div className="src-filter-right">
            <div className="src-table-actions">
              <button className="src-bulk-button" onClick={() => setIsBulkUploadModalOpen(true)}>📤 Bulk Upload</button>
              <button className="src-new-button" onClick={() => setIsNewLeadModalOpen(true)}>+ New Lead</button>
            </div>
          </div>
        </div>

        <div className="src-table-section">
          <div className="src-table-container">
            <table className="src-table">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Date</th>
                  <th>Source</th>
                  <th>Source By</th>
                  <th>Vertical</th>
                  <th>Activity</th>
                  <th>Description</th>
                  <th>Status</th>
                  {/* <th>Amount</th> */}
                  <th>Payment</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((lead) => {
                  const paymentInfo = getPaymentInfo(lead);
                  return (
                    <tr key={lead.id} className={lead.isFree ? 'src-free-lead-row' : ''}>
                      <td data-label="Sr.No">{lead.srNo}</td>
                      <td data-label="Date">{lead.enquiryDate}</td>
                      <td data-label="Source">
                        {lead.source}
                        {isSocialMediaLead(lead.source) && (
                          <span className="src-social-badge" title="Social Media - Free Lead">📱</span>
                        )}
                      </td>
                      <td data-label="Source By">{lead.assigned}</td>
                      <td data-label="Vertical">{lead.vertical}</td>
                      <td data-label="Activity">{lead.activity}</td>
                      <td data-label="Description">{lead.description}</td>
                      <td data-label="Status">
                        <span className={`src-status src-status-${lead.status.toLowerCase()}`}>{lead.status}</span>
                      </td>
                      {/* <td data-label="Amount">
                        {lead.isFree ? (
                          <span className="src-amount-free">Free</span>
                        ) : (
                          <span>₹{lead.amount?.toLocaleString() || '0'}</span>
                        )}
                      </td> */}
                      <td data-label="Payment">
                        {lead.status === "New" ? (
                          <button 
                            className={`src-payment-btn ${paymentInfo.className}`} 
                            onClick={() => handleDirectPayment(lead)} 
                            disabled={paymentInfo.disabled}
                            title={lead.isFree ? (isSocialMediaLead(lead.source) ? 'Social Media leads are free' : 'Free lead - No payment required') : ''}
                          >
                            {paymentInfo.text}
                          </button>
                        ) : (
                          <span className="src-payment-status-badge src-payment-completed">✓ Completed</span>
                        )}
                      </td>
                      <td data-label="Action">
                        {lead.status === "New" ? (
                          <button 
                            className={`src-convert-btn ${lead.isFree ? 'src-convert-free-btn' : ''}`}
                            onClick={() => openConvertModal(lead)} 
                            disabled={!lead.isFree && lead.paymentStatus !== "Paid"}
                          >
                            Convert →
                          </button>
                        ) : (
                          <button className="src-view-btn" onClick={() => openViewModal(lead)}>View Details</button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {filteredData.length === 0 && (<div className="src-no-results">No leads found matching your criteria</div>)}
          </div>
        </div>
      </div>

      {/* New Lead Modal */}
      {isNewLeadModalOpen && (
        <div className="src-modal-overlay" onClick={() => setIsNewLeadModalOpen(false)}>
          <div className="src-modal src-large-modal" onClick={(e) => e.stopPropagation()}>
            <div className="src-modal-header">
              <h3>➕ Add New Lead</h3>
              <button className="src-modal-close" onClick={() => setIsNewLeadModalOpen(false)}>×</button>
            </div>
            <div className="src-modal-body">
              <div className="src-form-row">
                <div className="src-form-group">
                  <label>Lead Name <span className="src-required">*</span></label>
                  <input type="text" name="leadName" value={formData.leadName} onChange={handleInputChange} placeholder="Enter full name" />
                </div>
                <div className="src-form-group">
                  <label>Mobile Number</label>
                  <input type="text" name="mobile" value={formData.mobile} onChange={handleInputChange} placeholder="+91 XXXXXXXXXX" />
                </div>
              </div>
              <div className="src-form-row">
                <div className="src-form-group">
                  <label>Email <span className="src-required">*</span></label>
                  <input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="email@company.com" />
                </div>
                <div className="src-form-group">
                  <label>WhatsApp</label>
                  <input type="text" name="whatsapp" value={formData.whatsapp} onChange={handleInputChange} placeholder="WhatsApp number" />
                </div>
              </div>
              <div className="src-form-row">
                <div className="src-form-group">
                  <label>Company <span className="src-required">*</span></label>
                  <input type="text" name="company" value={formData.company} onChange={handleInputChange} placeholder="Company name" />
                </div>
                <div className="src-form-group">
                  <label>Enquiry Date</label>
                  <input type="date" name="enquiryDate" value={formData.enquiryDate} onChange={handleInputChange} />
                </div>
              </div>
              <div className="src-form-row">
                <div className="src-form-group">
                  <label>Source</label>
                  <select name="source" value={formData.source} onChange={handleInputChange}>
                    {sourceOptions.map(opt => (
                      <option key={opt} value={opt}>
                        {opt} {opt === 'Social Media' ? '(Free)' : ''}
                      </option>
                    ))}
                  </select>
                  {isSocialMediaLead(formData.source) && (
                    <small className="src-social-note">📱 Social Media leads are automatically free</small>
                  )}
                </div>
                <div className="src-form-group">
                  <label>Location</label>
                  <input type="text" name="location" value={formData.location} onChange={handleInputChange} placeholder="City, State" />
                </div>
              </div>
              <div className="src-form-row">
                <div className="src-form-group">
                  <label>Assigned To</label>
                  <select name="assignedTo" value={formData.assignedTo} onChange={handleInputChange}>
                    {assigneeOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </div>
                <div className="src-form-group">
                  <label>Vertical</label>
                  <input type="text" name="vertical" value={formData.vertical} onChange={handleInputChange} placeholder="e.g., IT, Manufacturing" />
                </div>
              </div>
              <div className="src-form-row">
                <div className="src-form-group">
                  <label>Amount (₹)</label>
                  <input 
                    type="number" 
                    name="amount" 
                    value={formData.amount} 
                    onChange={handleInputChange} 
                    placeholder="0" 
                    disabled={formData.isFree || isSocialMediaLead(formData.source)}
                  />
                  {(formData.isFree || isSocialMediaLead(formData.source)) && (
                    <small className="src-social-note">Amount not applicable for free leads</small>
                  )}
                </div>
                <div className="src-form-group">
                  <label>Activity</label>
                  <input type="text" name="activity" value={formData.activity} onChange={handleInputChange} placeholder="Current status" />
                </div>
              </div>
              <div className="src-form-row">
                <div className="src-form-group src-checkbox-group">
                  <label className="src-checkbox-label">
                    <input 
                      type="checkbox" 
                      name="isFree" 
                      checked={formData.isFree || isSocialMediaLead(formData.source)} 
                      onChange={handleInputChange}
                      disabled={isSocialMediaLead(formData.source)}
                    />
                    <span> Free Lead (No payment required)</span>
                    {isSocialMediaLead(formData.source) && (
                      <span className="src-auto-free-badge">Auto-enabled for Social Media</span>
                    )}
                  </label>
                </div>
              </div>
              <div className="src-form-row">
                <div className="src-form-group src-full-width">
                  <label>Description</label>
                  <textarea name="description" value={formData.description} onChange={handleInputChange} rows="2" placeholder="Lead requirements..."></textarea>
                </div>
              </div>
              <div className="src-form-row">
                <div className="src-form-group src-full-width">
                  <label>Remarks</label>
                  <textarea name="remarks" value={formData.remarks} onChange={handleInputChange} rows="2" placeholder="Additional notes..."></textarea>
                </div>
              </div>
            </div>
            <div className="src-modal-footer">
              <button className="src-cancel-button" onClick={() => setIsNewLeadModalOpen(false)}>Cancel</button>
              <button className="src-save-button" onClick={handleAddLead}>Save Lead</button>
            </div>
          </div>
        </div>
      )}

      {/* Convert Modal */}
      {isConvertModalOpen && selectedLead && (
        <div className="src-modal-overlay" onClick={() => setIsConvertModalOpen(false)}>
          <div className="src-modal src-convert-modal" onClick={(e) => e.stopPropagation()}>
            <div className="src-modal-header">
              <h3>🔄 Convert to Enquiry</h3>
              <button className="src-modal-close" onClick={() => setIsConvertModalOpen(false)}>×</button>
            </div>
            <div className="src-modal-body">
              <p>Are you sure you want to convert this lead to an enquiry?</p>
              <div className="src-convert-preview">
                <div><strong>Lead:</strong> {selectedLead.leadName}</div>
                <div><strong>Company:</strong> {selectedLead.company}</div>
                <div><strong>Email:</strong> {selectedLead.email}</div>
                <div><strong>Mobile:</strong> {selectedLead.mobile}</div>
                <div>
                  <strong>Amount:</strong> {selectedLead.isFree ? 'Free' : `₹${selectedLead.amount?.toLocaleString() || '0'}`}
                </div>
                {selectedLead.isFree && (
                  <div>
                    <strong>Type:</strong> 🆓 Free Lead
                    {isSocialMediaLead(selectedLead.source) && ' (Social Media)'}
                  </div>
                )}
                {!selectedLead.isFree && selectedLead.paymentStatus === 'Paid' && (
                  <div><strong>Payment:</strong> ✅ Completed</div>
                )}
              </div>
              <p className="src-convert-note">After conversion, you can view all details.</p>
            </div>
            <div className="src-modal-footer">
              <button className="src-cancel-button" onClick={() => setIsConvertModalOpen(false)}>Cancel</button>
              <button className="src-convert-button-modal" onClick={handleConvertLead}>Confirm Convert</button>
            </div>
          </div>
        </div>
      )}

      {/* View Modal */}
      {isViewModalOpen && selectedLead && (
        <div className="src-modal-overlay" onClick={() => setIsViewModalOpen(false)}>
          <div className="src-modal src-view-modal" onClick={(e) => e.stopPropagation()}>
            <div className="src-modal-header">
              <h3>📄 Lead Details {selectedLead.isFree && '🆓'}</h3>
              <button className="src-modal-close" onClick={() => setIsViewModalOpen(false)}>×</button>
            </div>
            <div className="src-modal-body">
              <div className="src-view-details">
                <div className="src-view-section">
                  <h4>Contact Information</h4>
                  <div className="src-view-grid">
                    <div><strong>Lead Name:</strong> {selectedLead.leadName}</div>
                    <div><strong>Company:</strong> {selectedLead.company}</div>
                    <div><strong>Email:</strong> {selectedLead.email}</div>
                    <div><strong>Mobile:</strong> {selectedLead.mobile}</div>
                    <div><strong>WhatsApp:</strong> {selectedLead.whatsapp}</div>
                    <div><strong>Location:</strong> {selectedLead.location}</div>
                  </div>
                </div>
                <div className="src-view-section">
                  <h4>Lead Information</h4>
                  <div className="src-view-grid">
                    <div>
                      <strong>Source:</strong> {selectedLead.source}
                      {isSocialMediaLead(selectedLead.source) && (
                        <span className="src-view-social-badge">📱 Social Media</span>
                      )}
                    </div>
                    <div><strong>Assigned To:</strong> {selectedLead.assigned}</div>
                    <div><strong>Enquiry Date:</strong> {selectedLead.enquiryDate}</div>
                    <div><strong>Vertical:</strong> {selectedLead.vertical || '—'}</div>
                    <div><strong>Activity:</strong> {selectedLead.activity || '—'}</div>
                    <div>
                      <strong>Status:</strong>
                      <span className={`src-status src-status-${selectedLead.status.toLowerCase()}`}>
                        {selectedLead.status}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="src-view-section">
                  <h4>Payment & Description</h4>
                  <div className="src-view-grid">
                    <div>
                      <strong>Amount:</strong> {selectedLead.isFree ? 'Free' : `₹${selectedLead.amount?.toLocaleString() || '0'}`}
                    </div>
                    <div>
                      <strong>Payment Status:</strong>
                      {selectedLead.isFree ? (
                        <span className="src-free-badge">
                          Free Lead {isSocialMediaLead(selectedLead.source) ? '(Social Media)' : ''}
                        </span>
                      ) : (
                        <span className={`src-payment-status-badge ${selectedLead.paymentStatus === 'Paid' ? 'src-payment-completed' : 'src-payment-pending'}`}>
                          {selectedLead.paymentStatus}
                        </span>
                      )}
                    </div>
                    <div className="src-full-width">
                      <strong>Description:</strong> {selectedLead.description || '—'}
                    </div>
                    <div className="src-full-width">
                      <strong>Remarks:</strong> {selectedLead.remarks || '—'}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="src-modal-footer">
              <button className="src-close-button" onClick={() => setIsViewModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Bulk Upload Modal */}
      {isBulkUploadModalOpen && (
        <div className="src-modal-overlay" onClick={() => setIsBulkUploadModalOpen(false)}>
          <div className="src-modal src-bulk-modal" onClick={(e) => e.stopPropagation()}>
            <div className="src-modal-header">
              <h3>📤 Bulk Upload Leads</h3>
              <button className="src-modal-close" onClick={() => setIsBulkUploadModalOpen(false)}>×</button>
            </div>
            <div className="src-modal-body">
              <p className="src-bulk-instruction">Paste CSV data (columns order):</p>
              <div className="src-bulk-example">
                <strong>Format:</strong> Name, Mobile, Email, WhatsApp, Company, Source, Location, Assignee, Description, Vertical, Activity, Remarks, Date, Amount, IsFree<br /><br />
                <strong>Note:</strong> Social Media leads are automatically set as free leads.<br /><br />
                <strong>Example:</strong><br />
                John Doe, +91 9876543210, john@email.com, +91 9876543210, Tech Corp, Social Media, Mumbai, Priya (Exec), Need ERP, IT, Demo done, Follow up, 2024-01-20, 0, true
              </div>
              <textarea 
                className="src-bulk-textarea" 
                value={bulkData} 
                onChange={(e) => setBulkData(e.target.value)} 
                placeholder="Paste CSV data here..." 
                rows="10" 
              />
            </div>
            <div className="src-modal-footer">
              <button className="src-cancel-button" onClick={() => setIsBulkUploadModalOpen(false)}>Cancel</button>
              <button className="src-upload-button" onClick={handleBulkUpload}>Upload</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sourcing;